import state from './state'


/**
 * @description
 * Check if user is authenticated with state data (from local storage)
 * 
 * @param {@object} state with state data of auth module
 * @return {boolean} true is authenticated, false otherwise 
 */
const isAuthenticated = state => !! state.token

/**
 * @description
 * Get status of user (success, error or loading)
 * 
 * @param {object} state with state data of auth module
 * @return {string} 
 */
const authStatus = state => state.status

export default {
    isAuthenticated,
    authStatus,
}
